import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

import { getDataByUrl } from "@/handlers/commonApi";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import useIsMobile from "@/hooks/useIsMobile";

import { useContext } from "react";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  constituencyListData = null,
}) {
  const masterConfig = useContext(MasterConfigContext);
  const biharElectionKey = masterConfig["west_bengal_election"];
  const resultYear = biharElectionKey?.resultYear;
  const isMobileDevice = useIsMobile();
  const oldResult = {
    partyData: [
      {
        color: "#FF9933",
        partyName: "TMC",
        partySeat: "213",
      },
      {
        color: "#19AAED",
        partyName: "BJP+",
        partySeat: "77",
      },
      {
        color: "#19AAED",
        partyName: "LEFT+",
        partySeat: "0",
      },
       
      {
        color: "#CC0000",
        partyName: "OTH",
        partySeat: "2",
      },
    ],
  };
  const oldDesc =`West Bengal Assembly Elections Results 2026: इस बार पश्चिम बंगाल चुनाव में कौन जीतेगा रण? पश्चिम बंगाल की 294 सीटों पर चुनाव 2 चरणों में 23 और 29 अप्रैल को होगा. इसके बाद ही पता चल जाएगा कि TMC फिर रिपीट करेगी या BJP पलटेगी बाजी या कांग्रेस पार्टी करेगी खोल? साल 2021 में ममता बनर्जी की ऑल इंडिया तृणमूल कांग्रेस ने 213 सीटें जीती और लगातार तीसरी बार ममता बनर्जी की सरकार बनी थी. भाजपा को 77 सीटें मिली थीं और वो मुख्य विपक्षी पार्टी के रूप में उभरी थी. वहीं कांग्रेस पार्टी का खाता भी नहीं खुल पाया था. 4 मई को नतीजे घोषित होंगे. सबसे सटीक और सबसे तेज नतीजों के साथ राज्य के चुनाव का हर अपडेट जानने के लिए बने रहिए न्यूज Tak पर.`
 
  const newDesc = oldDesc
  // `West Bengal Assembly Elections Results 2025: इस बार के पश्चिम बंगाल विधानसभा चुनाव में कौन मारेगा बाजी? NDA या महागठबंधन...किसको मिलेगा बहुमत? BJP के साथ मिलकर JDU कर पाएगा कमाल या RJD और कांग्रेस की जोड़ी में VIP और लेफ्ट पार्टी मिल पलट देंगी गेम? नीतीश की बनेगी सरकार या प्रशांत किशोर की भविष्यवाणी होगी सच?  सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`;

  let metaData = {
    title: `West Bengal Assembly Chunav  ${resultYear} Results: पश्चिम बंगाल विधानसभा चुनाव रिजल्ट  ${resultYear} जानें सभी सीटों के नतीजे - NewsTak`,
    description: `West Bengal Assembly Election  ${resultYear} Results: पश्चिम बंगाल विधानसभा चुनाव  ${resultYear} के सभी सीटों के ताज़ा नतीजे और जीत-हार के आंकड़े देखें। जानें किस पार्टी को कितनी सीटें मिलीं और कौन बना रहा है सरकार — लाइव अपडेट्स के साथ।`,
    keywords: `पश्चिम बंगाल विधानसभा चुनाव ${resultYear} परिणाम, West Bengal Assembly Election ${resultYear} Results, West Bengal Chunav Result ${resultYear}, West Bengal Election Result Live, West Bengal Vidhan Sabha Result, West Bengal Election Seat Wise Result, पश्चिम बंगाल सीटवार चुनाव नतीजे, West Bengal Election Winner List, पश्चिम बंगाल चुनाव वोट गिनती, West Bengal Assembly Election Live Updates, किसे कितनी सीटें मिली पश्चिम बंगाल चुनाव, West Bengal Election Final Result ${resultYear}`,
  };

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}

          electionPath={`${electionCategory}/results`}
          isMobileDevice={isMobileDevice}
         
          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="west_bengal_election"
          stateName={"West Bengal"} //"Delhi"
          stateHindi={"पश्चिम बंगाल"}
          metaData={metaData}
          oldResult={oldResult}
          oldDesc={oldDesc}
          newDesc={newDesc}
          resultKey={"partiesDataBR"}
          constituencyListData={constituencyListData}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/results")[0];

  let electionCategory = url.split("/elections/")[1];
 
  if (!electionCategory) {
    return {
      notFound: true,
    };
  }

  try {
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let masterConfigData = await getMasterConfig();

    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });
    let electionConfigData = null;
    const electionConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.west_bengal_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
         ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    });
    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 120);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory,
        constituencyListData,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
